export enum ACCOUNTS_ACTION_TYPES {
  FETCH_ACCOUNTS = 'FETCH_ACCOUNTS',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
}
